import type { CSSProperties, ReactNode } from 'react';

type Props = {
  children: ReactNode;
  columns?: 2 | 3 | 4;
  className?: string;
  style?: CSSProperties;
};

export function SlaModalFieldGrid({
  children,
  columns = 3,
  className,
  style,
}: Props) {
  const classes = ['sla-modal-fields-grid', className]
    .filter(Boolean)
    .join(' ');

  return (
    <div
      className={classes}
      style={
        {
          ...style,
          '--sla-grid-columns': columns,
        } as CSSProperties
      }
    >
      {children}
    </div>
  );
}
